import { useEffect, useState } from 'react';
import { useGetFeatureFlags } from './useGetFeatureFlags';
import { useAuth0 } from '@auth0/auth0-react';
export var useFeatureFlags = function () {
    var isAuthenticated = useAuth0().isAuthenticated;
    var _a = useGetFeatureFlags(), data = _a.data, execute = _a.execute;
    var _b = useState({}), featureFlags = _b[0], setFeatureFlags = _b[1];
    useEffect(function () {
        if (isAuthenticated)
            execute();
    }, [execute, isAuthenticated]);
    useEffect(function () {
        if (data) {
            var flags_1 = {};
            data.forEach(function (ff) {
                if (ff.featureFlag) {
                    flags_1[ff.featureFlag] = ff.isEnabled === true;
                }
            });
            setFeatureFlags(flags_1);
        }
    }, [data]);
    return featureFlags;
};
